import { createContext, useContext } from 'react';
import type { MemberDto, WorkspaceDto } from '../api/types';

export interface WorkspaceContextValue {
  workspace: WorkspaceDto;
  members: MemberDto[];
}

const WorkspaceContext = createContext<WorkspaceContextValue | null>(null);

export const WorkspaceProvider = WorkspaceContext.Provider;

export function useWorkspace(): WorkspaceContextValue {
  const ctx = useContext(WorkspaceContext);
  if (!ctx) throw new Error('useWorkspace must be used within WorkspaceProvider');
  return ctx;
}

export function memberName(members: MemberDto[], userId: string | null): string {
  if (!userId) return '';
  const member = members.find((m) => m.id === userId);
  return member?.displayName || member?.email || userId;
}
